import { Box, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface DateFieldProps {
  label: string;
  value: string;
  onChange: (newValue: string) => void;
  all?: boolean;
  endLabel?: string;
  endValue?: string;
  onEndChange?: (newValue: string) => void;
}

function FormFieldDate({ label, value, onChange, all = false, endLabel, endValue, onEndChange }: DateFieldProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();

  // Estados de erro locais
  const [errorStart, setErrorStart] = useState<string | null>(null);
  const [errorEnd, setErrorEnd] = useState<string | null>(null);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n.language}>
      {/* START DATE */}
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
        <Typography variant="fieldHeader" width={theme.spacing(17)} sx={{ mt: 1 }}>
          {label}
        </Typography>
        <Stack direction="row" sx={{ width: '28%' }}>
          <DatePicker
            format="DD/MM/YYYY"
            value={value ? dayjs(value, 'DD/MM/YYYY') : null}
            onChange={(newValue: Dayjs | null) => onChange(newValue ? newValue.format('DD/MM/YYYY') : '')}
            onError={(reason) => {
              if (reason === 'invalidDate') {
                setErrorStart('Data inválida');
              } else {
                setErrorStart(null);
              }
            }}
            slotProps={{
              textField: {
                size: 'small',
                error: !!errorStart,
                helperText: errorStart || '',
                sx: { flexGrow: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } },
              },
            }}
            slots={{ openPickerIcon: () => null }}
          />
        </Stack>
      </Box>

      {/* END DATE */}
      {all && endLabel && endValue !== undefined && onEndChange && (
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
          <Typography variant="fieldHeader" width={theme.spacing(17)} sx={{ mt: 1 }}>
            {endLabel}
          </Typography>
          <Stack direction="row" sx={{ width: '28%' }}>
            <DatePicker
              format="DD/MM/YYYY"
              value={endValue ? dayjs(endValue, 'DD/MM/YYYY') : null}
              onChange={(newValue: Dayjs | null) => onEndChange(newValue ? newValue.format('DD/MM/YYYY') : '')}
              onError={(reason) => {
                if (reason === 'invalidDate') {
                  setErrorEnd('Data inválida');
                } else {
                  setErrorEnd(null);
                }
              }}
              slotProps={{
                textField: {
                  size: 'small',
                  error: !!errorEnd,
                  helperText: errorEnd || '',
                  sx: { flexGrow: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } },
                },
              }}
              slots={{ openPickerIcon: () => null }}
            />
          </Stack>
        </Box>
      )}
    </LocalizationProvider>
  );
}

export default FormFieldDate;
